/* @flow */

import { CanvasRenderer } from './canvas.renderer';
import { ChartControls } from './chart-controls';
import { ChartModel } from './chart.model';
import { CANVAS_HEIGHT, CANVAS_WIDTH } from './constants';
import { Header } from './header';
import { Legend } from './legend';

export function chart (el: HTMLElement, path: string, title) {
    window.fetch(path + '/overview.json').then(response => { return response.json(); }).then(result => {
        const chart = new ChartModel(result);

        const header = new Header(el, chart, title);

        const canvasWrapper = document.createElement('div');
        canvasWrapper.style.position = 'relative';
        canvasWrapper.style.width = CANVAS_WIDTH + 'px';
        canvasWrapper.style.height = CANVAS_HEIGHT + 'px';
        el.appendChild(canvasWrapper);

        const canvas = document.createElement('canvas');
        canvas.width = CANVAS_WIDTH;
        canvas.height = CANVAS_HEIGHT;
        canvasWrapper.appendChild(canvas);
        const renderer = new CanvasRenderer(canvas, chart);

        chart.columns.forEach(c => {
            const lbl = document.createElement('label');
            lbl.className = 'active';
            const chbx = document.createElement('input');
            const icon = document.createElement('i');
            lbl.style.backgroundColor = c.color;
            icon.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" width="16px" height="16px" version="1.1" style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
                                viewBox="0 0 4276.58 3552.91"
                                 xmlns:xlink="http://www.w3.org/1999/xlink">
                                 <g>
                                  <path class="fil0" d="M1531.62 2485.14l1985.26 -2334.11c153.43,-180.4 428.55,-202.33 608.8,-48.81 180.24,153.52 202.15,428.37 48.79,608.67l-2287.96 2690.01c-3.07,3.61 -6.18,7.17 -9.39,10.66l-1.36 1.47c-1.58,1.72 -3.16,3.44 -4.76,5.14l-8.4 8.64c-168.12,168.11 -442.58,168.12 -610.69,0l-1125.82 -1125.82c-168.12,-168.12 -168.12,-442.57 0,-610.69 168.12,-168.12 442.57,-168.12 610.69,0l794.84 794.84z"/>
                                 </g>
                                </svg>`;
            chbx.type = 'checkbox';
            chbx.checked = true;
            chbx.onchange = () => {
                lbl.classList.toggle('active');
                renderer.toggleColumn(c.key);
                if (chbx.checked) {
                    lbl.style.backgroundColor = c.color;
                    lbl.style.color = '#fff';
                } else {
                    lbl.style.backgroundColor = 'transparent';
                    lbl.style.color = c.color;
                    lbl.style.borderColor = c.color;
                }
            };
            lbl.appendChild(chbx);
            lbl.appendChild(icon);
            const lblText = document.createTextNode(c.name);
            lbl.appendChild(lblText);
            el.appendChild(lbl);
        });

        const chartControls = new ChartControls(canvasWrapper, chart);
        chartControls.on('move', (from, to) => {
            renderer.changeSelection(from, to);
            header.update(from, to);
        });
        const legend = new Legend(canvasWrapper, chart);
    });
}
